import { RouteObject } from 'react-router';
import App from './app';
import ProjectsListPage from './features/projects/ProjectsListPage';
import SettingsPage from './features/settings/SettingsPage';
import ProjectSettingsPage from './features/projects/ProjectSettingsPage';
import ProjectPage from './features/projects/ProjectPage';
import FileEditorPage from './features/editors/FileEditorPage';
import FileRevisionsPage from './features/file-revisions/FileRevisionsPage';

const routes: RouteObject[] = [
  {
    Component: App,
    path: '/',
    index: true,
  },
  {
    Component: App,
    HydrateFallback: () => 'loading...',
    path: ':orgSlug',
    children: [
      {
        index: true,
        element: <ProjectsListPage />,
      },
      {
        path: 'home',
        element: <ProjectsListPage />,
      },
      {
        path: 'settings/:tab?',
        element: <SettingsPage />,
      },
      {
        path: 'p/:projectId/settings/:tab?',
        element: <ProjectSettingsPage />,
      },
      {
        path: 'p/:projectId',
        element: <ProjectPage />,
      },
      {
        path: 'p/:projectId/edit',
        element: <FileEditorPage />,
      },
      {
        path: 'p/:projectId/revisions',
        element: <FileRevisionsPage />,
      },
    ],
  },
];

export default routes;
